<template>
    <div class="container episode-listing">
        <div class="float-right"><span>Duration: {{duration}}</span></div>
        <h2>{{ $t('headings.title') }}</h2>
        <div class="card">
            <div class="card-body">
                <draggable
                    v-model="episodes"
                    @end="orderEpisodes"
                    element="div"
                    class=""
                    :options="{ handle: '.drag-handle' }"
                >
                    <Episode
                        v-for="episode,index in episodes"
                        :index="index"
                        :episode="episode"
                        :key="episode.id"
                        :snickId="snickId"
                        v-on:delete-episode="deleteEpisode"
                        :extensions="extensions"
                        :lastEpisode="episodes.length === index + 1"
                        :canPublish="canPublish"
                    />
                </draggable>
                <a slot="footer" v-on:click="createEpisode" class="btn btn-primary text-white btn-block">{{$t('interface.btnNew')}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import Episode from './Episode';
    import _ from "lodash";

    export default {
        props: [ 'snickId', 'extensions', 'canPublish' ],
        components: {
            Episode,
            draggable,
        },
        methods: {
            getEpisodes() {
                // Get a fresh copy of the episode list
                $.getJSON('/docus/' + this.snickId + '/episodes', json => {
                    this.episodes = json;
                });
            },
            orderEpisodes() {
                const url=`/docus/${this.snickId}/episodes/order`;
                axios.post(url, this.episodes);
            },

            createEpisode: function (e) {
                e.preventDefault();
                const url=`/docus/${this.snickId}/episode`;
                axios.post(url).then((response) => {
                    this.episodes = response.data;
                });
            },
            deleteEpisode: function (index) {
                const url = `/docus/${this.snickId}/episodes/${this.episodes[index].id}`;

                if (!confirm(this.$t('messages.confirmDeleteEpisode'))) return false;

                this.episodes.splice(index, 1);
                axios.delete(url).catch((error) => {
                    this.getEpisodes();
                });
            },
        },
        i18n: {
            locale: 'en',
            messages: {
                en: {
                    headings: {
                        title: 'Episodes',
                    },
                    interface: {
                        btnNew: 'Create new episode',
                        btnEdit: 'Edit',
                        btnSettings: 'Settings',
                    },
                    episode: {
                        published: 'Published',
                        unpublished: 'Unpublished',
                        scheduled: 'Scheduled',
                        untitled: 'Untitled episode',
                    },
                    messages: {
                        confirmDeleteEpisode: 'Are you sure you want to permanently delete the entire episode?',
                    },
                },
                sv: {
                    headings: {
                        title: 'Episoder',
                    },
                    interface: {
                        btnNew: 'Skapa ny episod',
                        btnEdit: 'Redigera',
                        btnSettings: 'Inställningar',
                    },
                    episode: {
                        published: 'Publicerad',
                        unpublished: 'Opublicerad',
                        scheduled: 'Schemalagd',
                        untitled: 'Namnlös episod',
                    },
                    messages: {
                        confirmDeleteEpisode: 'Är du säker på att du vill radera hela episoden?',
                    },
                }
            }
        },
        data: function () {
            return {
                added: 0,
                episodes: []
            };
        },
        computed: {
            duration: function() {
                const duration = _.reduce(this.episodes, (carry, episode) => {
                    return carry + episode.duration;
                }, 0);

                const hours = _.floor(duration / 3600);
                const minutes = _.padStart(_.floor(duration % 3600 / 60), 2, '0');
                const seconds = _.padStart(_.floor(duration % 60), 2, '0');

                if (hours) return `${hours}:${minutes}:${seconds}`;
                return `${minutes}:${seconds}`
            },
        },
        mounted() {
            this.getEpisodes();
        }
    };
</script>
